import { render } from "./EscapadoresDisponiveis.vue?vue&type=template&id=1495b725&scoped=true&ts=true"
import script from "./EscapadoresDisponiveis.vue?vue&type=script&lang=ts"
export * from "./EscapadoresDisponiveis.vue?vue&type=script&lang=ts"

import "./EscapadoresDisponiveis.vue?vue&type=style&index=0&id=1495b725&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1495b725"]])

export default __exports__